<template>
  <!-- 表单弹窗 -->
  <Modal
    width="1200"
    class-name="formModal"
    :value="showModal"
    :title="title"
    :loading="loading"
    :mask-closable="false"
    @on-ok="confirm('form')"
    @on-visible-change="visibleChange">
    <!-- @on-cancel="searchProject"> -->
    <Form ref="form" :model="form" label-position="left" :label-width="128" :rules="rules">
      <Row>
        <input-select span="6" label="数据来源：" :disabled="formDisabled===0" prop="data_sources" v-model="form.data_sources" type="select" :options="options.dataSources"></input-select>
        <input-select span="6" label="地区：" :disabled="editPermission ? false : formDisabled===0" prop="address" v-model="form.address" type="select" :options="options.address"></input-select>
        <input-select span="12" label="项目名称：" :disabled="editPermission ? false : formDisabled===0" prop="project_name" v-model="form.project_name" :title="form.project_name"></input-select>
      </Row>
      <Row>
        <input-select span="6" label="项目负责人：" :disabled="!editPermission" prop="principal" v-model="form.principal"></input-select>
        <input-select span="6" label="项目编号：" :disabled="editPermission ? false : formDisabled===0" prop="project_num" v-model="form.project_num"></input-select>
        <Col span="7">
          <FormItem label="可代理项目类型：">
            <CheckboxGroup v-model="form.property">
              <Checkbox label="服务类" :disabled="editPermission ? false : formDisabled===0"></Checkbox>
              <Checkbox label="货物类" :disabled="editPermission ? false : formDisabled===0"></Checkbox>
              <Checkbox label="工程类" :disabled="editPermission ? false : formDisabled===0"></Checkbox>
            </CheckboxGroup>
          </FormItem>
        </Col>
        <Col span="5">
          <FormItem label="是否需要盖章报名资料：" :label-width="158" required>
            <RadioGroup v-model="enroll">
              <Radio label="是" :disabled="!( !form.project_status || form.project_status === '立项审核退回' || form.project_status === '未发起')"></Radio>
              <Radio label="否" :disabled="!( !form.project_status || form.project_status === '立项审核退回' || form.project_status === '未发起')"></Radio>
            </RadioGroup>
          </FormItem>
        </Col>
      </Row>
      <Row>
        <input-select span="12" label="采购人：" :disabled="editPermission ? false : formDisabled===0" prop="buyer" v-model="form.buyer"></input-select>
        <input-select span="6" label="采购人联系人：" :disabled="editPermission ? false : formDisabled===0" prop="contact" v-model="form.contact"></input-select>
        <input-select span="6" label="采购人联系方式：" :disabled="editPermission ? false : formDisabled===0" prop="buyer_contact" v-model="form.buyer_contact"></input-select>
      </Row>
      <Row>
        <input-select span="12" label="采购代理：" :disabled="editPermission ? false : formDisabled===0" prop="agency" v-model="form.agency"></input-select>
        <input-select span="9" label="行业系统：" :disabled="editPermission ? false : formDisabled===0" prop="industry" v-model="form.industry" type="select" :options="options.industry"></input-select>
      </Row>
      <Row>
        <input-select span="12" label="电子投标平台：" :disabled="editPermission ? false : formDisabled===0" prop="elecBidSys" v-model="form.elecBidSys" type="select" :options="options.bid_platform"></input-select>
        <input-select span="12" label="投标平台备注：" :disabled="editPermission ? false : form.project_status==='不参与'||form.project_status==='投标成功'||form.project_status==='投标失败'"  v-model="form.bidSysRemark"></input-select>
      </Row>
      <Row>
        <input-select span="12" label="相关链接：" :disabled="editPermission ? false : formDisabled===0" prop="url" v-model="form.url" :title="form.url"></input-select>
        <input-select span="12" label="报名地址：" :disabled="editPermission ? false : formDisabled===0" prop="apply_address" v-model="form.apply_address" :title="form.apply_address"></input-select>
      </Row>
      <Row>
        <input-select span="6" label="项目报名时间：" :disabled="editPermission ? false : formDisabled===0" prop="apply_date" v-model="form.apply_date" type="datetime"></input-select>
        <input-select span="6" label="至" :disabled="editPermission ? false : formDisabled===0" prop="apply_date2" v-model="form.apply_date2" type="datetime"></input-select>
        <input-select span="6" label="项目预算：" :disabled="editPermission ? false : formDisabled===0" prop="budget" v-model="form.budget"></input-select>
        <input-select span="6" label="(单位:万元)" type="text"></input-select>
      </Row>
      <Row>
        <input-select span="6" label="开标时间：" :disabled="editPermission ? false : formDisabled===0" prop="bid_date" v-model="form.bid_date" type="datetime"></input-select>
        <input-select span="6" label="招标形式：" :disabled="editPermission ? false : formDisabled===0" prop="modality" v-model="form.modality" type="select" :options="options.modality"></input-select>
        <input-select span="12" label="报价要求：" :disabled="editPermission ? false : !(form.project_status==='等待上传投标文件' && form.participation==='是')" prop="offer_demand" :required="form.project_status==='等待上传投标文件' && form.participation==='是'" v-model="form.offer_demand"></input-select>
      </Row>
      <Row>
        <input-select span="6" label="保证金金额(元)：" :disabled="editPermission ? false : !(form.project_status==='等待上传投标文件' && form.participation==='是')" prop="bond" :required="form.project_status==='等待上传投标文件' && form.participation==='是'" v-model="form.bond"></input-select>
        <input-select span="6" label="保证金账户：" :disabled="editPermission ? false : !(form.project_status==='等待上传投标文件' && form.participation==='是')" prop="marginAccount" :required="form.project_status==='等待上传投标文件' && form.participation==='是'" v-model="form.marginAccount"></input-select>
        <input-select span="12" label="保证金账户名：" :disabled="editPermission ? false : !(form.project_status==='等待上传投标文件' && form.participation==='是')" prop="marginAccountName" :required="form.project_status==='等待上传投标文件' && form.participation==='是'" v-model="form.marginAccountName"></input-select>
      </Row>
      <Row>
        <input-select span="6" label="合同期限从" :disabled="editPermission ? false : form.project_status!=='待结项'" prop="contract_date" :required="form.project_status==='待结项'" v-model="form.contract_date" type="date"></input-select>
        <input-select span="6" label="至" :disabled="editPermission ? false : form.project_status!=='待结项'" prop="contract_date2" :required="form.project_status==='待结项'" v-model="form.contract_date2" type="date"></input-select>
        <Col span="6">
          <FormItem label="是否参投：" :required="form.project_status==='等待上传投标文件'">
            <RadioGroup v-model="form.participation">
              <Radio label="是" :disabled="form.project_status!=='等待上传投标文件'"></Radio>
              <Radio label="否" :disabled="form.project_status!=='等待上传投标文件'"></Radio>
            </RadioGroup>
          </FormItem>
        </Col>
      </Row>
      <Row>
        <input-select span="12" label="备注：" :disabled="editPermission ? false : form.project_status==='不参与'||form.project_status==='投标成功'||form.project_status==='投标失败'" v-model="form.remark"></input-select>
        <input-select span="12" type="text" label="关联项目名称：" :content="contactProject.project_name" v-show="title==='基本信息'&&form.sourceId"></input-select>
        <!-- <input-select span="12" type="text" label="关联项目名称：" :content="form.project_name" v-show="title==='到期认领'"></input-select> -->
      </Row>
    </Form>
  </Modal>
</template>

<script>
import ajax from '@/lib/ajax'
import requestUrls from '@/lib/requestUrls'
import axios from 'axios'
import inputSelect from '@/components/inputSelect'
import { formatDate } from "@/lib/tool"

export default {
  props: {
    showModal: Boolean,
    title: String,
    formData: Object
  },
  components: {
    inputSelect
  },
  computed: {
    formDisabled() {
      if (this.form.project_status==='') {
        return 0
      }
      if (this.form.isEnroll === true) {
        // 项目报名 提交 报名文件 审核后基本信息禁填
        switch (this.form.project_status) {
          case '未发起': case '立项审核退回': case '立项审核中': case '等待上传报名资料': return 1
          break
          default: return 0
        }
      } else if (this.form.isEnroll === false) {
      // 项目不报名 提交 投标文件 核后基本信息禁填
        switch (this.form.project_status) {
          case '未发起': case '立项审核退回': case '立项审核中': case '等待上传投标文件': return 1
          break
          default: return 0
        }
      }
    },
    roleNames() {
      return this.$store.state.session.roleNames
    },
    editPermission() {
      // 获取用户角色信息
      return this.$store.getters["session/hasRoles"]("军工事业部")
    }
  },
  data() {
    return {
      formKey: [
        'data_sources', // 数据来源
        'address',  // 地区
        'project_name',  // 项目名称
        'project_num',  // 项目编号
        'buyer',  // 采购人
        'contact',  // 采购人联系人
        'buyer_contact',  // 采购人联系方式
        'agency',  // 采购代理
        'url',  // 相关链接
        'apply_address',  // 代理地址
        'participation',  // 是否参与
        'industry',  // 行业系统
        'property',  // 行业性质
        'modality',  // 招标形式
        'budget',  // 项目预算
        'apply_date',  // 报名开始时间
        'apply_date2',  // 报名结束时间
        'bid_date',  // 投标时间
        'contract_date',  // 合同期限开始
        'contract_date2',  // 合同期限结束
        'offer_demand',  // 报价要求
        'bond',  // 保证金
        'principal',  // 项目负责人
        'marginAccount',  // 保证金账户
        'remark',  // 备注
        'reviewStatus',  // 审核状态
        'marginAccountName',  // 保证金户名
        'elecBidSys',  // 电子评标平台
        'bidSysRemark',  // 投标平台备注
        'participationReason',  //  不参与原因
        'project_status',  // 项目状态
        'reviewPerson',  // 审核人员
        'sourceId',  // 来源id 关联项目id
        "isMIReview"
        ],
      form: {},
      loading: true,
      rules: {
        data_sources: [
          { required: true, trigger: 'blur' }
        ],
        address: [
          { required: true, trigger: 'blur' }
        ],
        project_name: [
          { required: true, trigger: 'blur' }
        ],
        principal: [
          { required: true, trigger: 'blur' }
        ],
        buyer: [
          { required: true, trigger: 'blur' }
        ], 
        industry: [
          { required: true, trigger: 'blur' }
        ], 
        elecBidSys: [
          { required: true, trigger: 'blur' }
        ], 
        url: [
          { required: true, trigger: 'blur' }
        ], 
        apply_address: [
          { required: true, trigger: 'blur' }
        ], 
        apply_date: [
          { required: true, trigger: 'blur' }
        ], 
        apply_date2: [
          { required: true, trigger: 'blur' }
        ], 
        bid_date: [
          { required: true, trigger: 'blur' }
        ], 
        modality: [
          { required: true, trigger: 'blur' }
        ]
      },
      activeRules: ['bond', 'marginAccount', 'marginAccountName', 'offer_demand'],
      options: {
        dataSources: [
          {
            id: 1,
            value: '分公司',
          },
          {
            id: 2,
            value: '军工事业部',
          },
        ],
        address: [],
        participation: [
          {
            id: 1,
            value: '是',
          },
          {
            id: 2,
            value: '否',
          },
        ],
        industry: [],
        property: [],
        modality: [
          {
            id: 1,
            value: '公开招标',
          },
          {
            id: 2,
            value: '邀请招标',
          },
          {
            id: 3,
            value: '摇珠',
          },
          {
            id: 4,
            value: '竞争性磋商',
          },
          {
            id: 5,
            value: '竞价',
          },
          {
            id: 6,
            value: '比选',
          },
        ],
        bid_platform: [
          {
            id: 1,
            value: '南方电网公司电子商务系统',
          },
          {
            id: 2,
            value: '中国移动采购与招标网',
          },
          {
            id: 3,
            value: '无',
          },
        ]
      },
      auditorArr: ["黄韵丝", "何慧儿", "冯嘉茹"],
      propertyArr: [],
      systemArr: [],
      enroll: '',
      contactProject: {
        project_name: ''
      }
    }
  },
  watch: {
    formData(val) {
      this.form = val
      this.dataFormat()
      if (!val.project_status) {
        // 清除动态表单限制
        this.activeRules.forEach(rule => {
          delete this.rules[rule]
        })
        if (this.rules.contract_date) {delete this.rules[contract_date]}
        if (this.rules.contract_date2) {delete this.rules[contract_date2]}
      }
      if (val.project_status==='等待上传投标文件' && val.participation === '是') {
        this.activeRules.forEach(rule => {
          this.$set(this.rules, rule, [{ required: true, trigger: 'blur' }])
        })
      } 
      if (val.project_status==='待结项') {
        this.$set(this.rules, 'contract_date', [{ required: true, trigger: 'blur' }])
        this.$set(this.rules, 'contract_date2', [{ required: true, trigger: 'blur' }])
      }
      // 获取关联项目信息
      if (this.form.sourceId) {
        ajax.get(`${requestUrls.ClBidManage.GetById}?id=${this.form.sourceId}`).then(res => {
          this.contactProject = res.data.result
        })
      }
    }
  },
  async created() {
    // 初始化表单
    this.formKey.forEach(el => {
      if (el !== 'property') {
        this.$set(this.form,el,'')
      } else {
        this.form.property = []
      }
    })
    // 根据角色获取地区
    // let childRep = await ajax.get(requestUrls.CLDistrict.GetList)
    let childRep = await ajax.get(requestUrls.CLDistrict.GetListWithoutRole)
    this.childCompanies = childRep.data.result.items
    const childCompanies = JSON.parse(JSON.stringify(this.childCompanies))
    childCompanies.forEach(obj => {
      this.getAuditor(obj.name)
    })
    this.childCompanies.push({
      id: 0,
      name: '全部'
    })
    // 分公司选项
    this.options.address = this.childCompanies.slice(0,-1)
    this.options.address.forEach(el => {
      this.$set(el, 'value', el.name)
    })
    // 获取项目性质
    let rep = await ajax.get(requestUrls.AbpDataDict.GetList, {
      params: {
        filter: 'itemType=="采购类别"'
      }
    });
    if (rep.data.success && rep.data.result.items.length > 0) {
      this.propertyArr = rep.data.result.items;
      this.propertyArr.push({
        id: 0,
        itemName: "全部"
      });
    }
    // 获取行业系统
    let system = await ajax.get(requestUrls.AbpDataDict.GetList, {
      params: {
        filter: 'itemType=="IndustrySystem"'  
      }
    })
    this.systemArr = system.data.result.items
    this.systemArr.push({
      id: 0,
      itemName: '全部'
    })
    // 表单行业系统选项
    this.systemArr = this.systemArr.filter(item => { return item.itemName != '部队系统' })
    this.options.industry = this.systemArr.slice(0,-1)
    this.options.industry.forEach(el => {
      this.$set(el, 'value', el.itemName)
    })
    this.$emit('init', this.childCompanies, this.propertyArr, this.systemArr )
  },
  methods: {
    dataFormat() {
      Object.keys(this.form).forEach(key => {
        if (this.form[key] !== '' && this.form[key] !== null) {
          switch(key) {
            case 'bond':
            case 'budget':
            case 'bid_budget':
            case 'buyer_contact':
            case 'my_offer':
            case 'marginAccount':
              this.form[key] = this.form[key].toString()
            break
            case 'property':
            if (typeof this.form[key] === 'string') {
              this.form[key] = this.form[key].split('+')
            }
          }
        } else {
          if (key === 'property') {
            this.form[key] = []
          }
        }
      })
    },
    getAuditor(params) {
      switch (params ? params : this.form.address) {
        case '北京':
        case '广州':
          return this.auditorArr[0]    // 黄韵丝
          break
        case '贵州':
        case '云南':
        case '佛山':
        case '中山':
        case '珠海':
        case '江门':
        case '肇庆':
        case '云浮':
        case '阳江':
        case '茂名':
        case '湛江':
          return this.auditorArr[1]   // 何慧儿
          break
        case '重庆':
        case '四川':
        case '清远':
        case '韶关':
        case '深圳':
        case '惠州':
        case '东莞':
        case '汕尾':
        case '汕头':
        case '河源':
        case '梅州':
        case '揭阳':
          return this.auditorArr[2]   // 冯嘉茹
          break
        default:
          // 过滤未知审核人员的地区
          let obj = this.childCompanies.filter((item, index) => {
            if (item.name === params) {
              this.childCompanies.splice(index, 1)
            }
          })
      }
    },
    visibleChange(status) {
      if(status) {
        this.enroll = this.form.isEnroll == undefined ? '' : this.form.isEnroll ? '是' : '否'
      }
      this.$emit('visibleChange',status)
    },
    // 重置表单验证
    reset() {
      this.activeRules.forEach(rule => {	  
        Object.keys(this.rules).forEach(key => {	    
          if (rule === key) {	     
            delete this.rules[key]	    
          }	     
        })	  
      })
    },
    dateCheck(from,to) {
      let start,end
        start = new Date(this.form[from])
        end = new Date(this.form[to])
      if (start > end) {
        this.$Modal.error({
          title: '错误提示',
          content: '起始日期大于结束日期，请重新选择！'
        })
        return true
      }
    },
    // 点击表单确定按钮
    confirm(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          if (this.enroll === '') {
            this.loading = false
            this.$Message.info('请选择是否报名')
            setTimeout(() => {
              this.loading = true
            },100)
            return
          }
          if ((this.form.bond || parseFloat(this.form.bond) === 0) && isNaN(parseFloat(this.form.bond))) {
            this.loading = false
            this.$Message.info('保证金金额请输入数字')
            setTimeout(() => {
              this.loading = true
            },100)
            return
          }
          if (this.form.budget && isNaN(parseFloat(this.form.budget))) {
            this.loading = false
            this.$Message.info('项目预算请输入数字')
            setTimeout(() => {
              this.loading = true
            },100)
            return
          }
          if (this.dateCheck('contract_date','contract_date2')) {
            this.loading = false
            setTimeout(() => {
              this.loading = true
            },100)
            return
          }
          if (this.dateCheck('apply_date','apply_date2')) {
            this.loading = false
            setTimeout(() => {
              this.loading = true
            },100)
            return
          }
          // // 若数据来源为“战略客户中心”，项目立项无需审核，直接显示“参与”状态为“是”，仅系统提醒战略客户中心区域人员有项目立项即可
          // let description = `项目：${this.form.project_name} 已添加成功,请确认是否参与`
          // if (this.form.data_sources === '战略客户中心') {
            // this.form.reviewPerson = this.getAuditor()
          //   this.form.participation = '是'
          //   description = `项目：${this.form.project_name} 已立项,投标文件准备中`
          // }
          this.form.isMIReview = true
          this.form.isEnroll = this.enroll === '是' ? true : false
			    this.form.projectDate = this.title === '添加项目' || this.title === '到期认领' ? formatDate() : ''  // 立项时间
          this.form.project_status = this.title === '添加项目' || this.title === '到期认领' ? '未发起' : this.form.project_status
          // if (this.form.workFlowId && ) {
          //   this.form.project_status = this.form.data_sources === '战略客户中心' ? '等待上传投标文件' : '立项审核中'
          // }
          let req = JSON.parse(JSON.stringify(this.form)) 
          if (req.property) {
            req.property = req.property.join('+')
          }
          // req.project_status = '立项审核退回'         // 修改状态用
          // req.reviewPerson = '叶嘉敏'         // 修改操作人员用
          // 将表单数据格式化后传入后台
          ajax.post(requestUrls.ClBidManage.CreateOrUpdate,{
            clBidManage: req
          }).then(res => {
            this.dataFormat()
            setTimeout( async() => {
              this.$emit('visibleChange',false)
              if (this.title === '添加项目') {
                // 刷新列表
                this.$emit('updateData')
                this.$Message.success(`添加项目成功!`)
              } else if (this.title === '到期认领') {
                // 项目认领状态
                ajax.get(`${requestUrls.ClBidManage.GetById}?id=${res.data.result.sourceId}`).then(rep => {
                  let sourceProject = rep.data.result
                  sourceProject.isClaim = true
                  ajax.post(requestUrls.ClBidManage.CreateOrUpdate, {
                    clBidManage: sourceProject
                  }).then(() => {
                    // 刷新列表
                    this.$emit('updateData')
                    this.$Message.success(`项目认领成功!`)
                  })
                })
              } else {
                this.$Message.success(`编辑${this.title}成功!`)
              }
            }, 1200);
          }).catch(() => {
            this.$emit('visibleChange',false)
            if (this.title === '添加项目' || this.title === '到期认领') {
              this.$Message.error(`${this.title}失败!`)
            } else {
              this.$Message.error(`编辑${this.title}失败!`)
            }
          })
        } else {
          this.loading = false
          this.$Message.error('请完善信息填写!');
          setTimeout(() => {
            this.loading = true
          },100)
        }
      })
    }
  }
};
</script>

<style lang="less" scoped>
.formModal .ivu-checkbox-disabled .ivu-checkbox-inner:after {
  border-color: #495060;
}
.formModal .ivu-modal-body {
  padding-left: 0 !important;
  background-color: #f7f7f7;
}

/deep/ .formModal {
  .ivu-input[disabled],
  .ivu-select-disabled,
  .ivu-select-selection,
  .ivu-checkbox-disabled + span {
    color: #495060 !important;
  }
  .ivu-form-item {
    margin-bottom: 10px;
  }
  .ivu-form-item-error-tip {
    display: none;
  }
  .ivu-form-item-label {
    padding-left: 15px !important;
    white-space: nowrap;
  }
}
</style>